import { motion } from "framer-motion";
import { fadeUp, revealOnce } from "../../motion";
import "../../css/Motivation.css";

const Motivation = () => {
  return (
    <section className="section motivation">
      <motion.div
        className="motivation__inner container"
        variants={fadeUp}
        {...revealOnce}
      >
        <span className="eyebrow">Motivation</span>
        <h2 className="motivation__title">
          Driven by the pursuit of success
        </h2>
        <p className="motivation__text">
          With a relentless drive for excellence, I&apos;m motivated to deliver
          top-notch solutions that surpass expectations and create meaningful
          outcomes — in every project I take on.
        </p>
      </motion.div>
    </section>
  );
};

export default Motivation;
